<template>
  <input
    class="block appearance-none border px-3 py-2 shadow-sm focus:outline-none disabled:opacity-50 dark:bg-gray-900 dark:text-white dark:placeholder-gray-300 sm:text-sm"
    :class="classes + ' ' + roundedClass + ' ' + width"
    v-model="inputValue"
    :type="localType"
    :placeholder="placeholder"
    ref="input"
    :pattern="localPattern"
    :novalidate="localNovalidate"
  />
</template>

<script>
import { errorClasses } from '../common'

export default {
  props: {
    modelValue: {
      type: [String, Number],
    },
    error: {
      default: null,
    },
    rounded: String,
    width: {
      default: 'w-full',
    },
    type: {
      default: 'text',
    },
    placeholder: {
      default: null,
    },
    integer: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  computed: {
    inputValue: {
      get() {
        return this.modelValue
      },

      set(val) {
        this.$emit('update:modelValue', this.formatValue(val))
      },
    },

    classes() {
      return errorClasses(this.error)
    },

    localType() {
      if (this.integer) return 'tel'

      return this.type
    },

    localPattern() {
      if (this.integer) return '[0-9]*'

      return null
    },

    localNovalidate() {
      if (this.integer) return 'true'
      return false
    },

    roundedClass() {
      if (this.rounded === 'left') return 'rounded-l-md'
      else if (this.rounded === 'right') return 'rounded-r-md'
      else return 'rounded-md'
    },
  },

  mounted() {
    if (this.integer || this.currency)
      if (String(this.modelValue).includes('.'))
        this.emit(this.formatValue(Number(this.modelValue).toFixed(2)))
      else this.emit(this.formatValue(this.modelValue))
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    },

    formatValue(value) {
      if (value == null) return

      if (this.integer) {
        return String(value)
          .replace(/\D/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else if (this.currency) {
        return String(value)
          .replace(/[^.\-\d]/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }

      return value
    },

    emit(value) {
      this.$nextTick(() => {
        this.$emit('update:modelValue', value)
      })
    },
  },
}
</script>
